var mainSlider, cardSlider, filterSlider, placesSlider, excursionSlider;
var cardMass = [];

function sliderInit() {
    cardMass.forEach(function (elem) {
        elem.destroy();
    });
    cardMass = [];
    $(".card-slider .swiper-container").each(function (index, element) {
        var $this = $(this);
        cardSlider = new Swiper($this, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            lazy: true,
            preloadImages: false,
            loadPrevNext: true,
            loadPrevNextAmount: 1,
            navigation: {
                nextEl: $this.find(".next-slide")[0],
                prevEl: $this.find(".prev-slide")[0],
                disabledClass: 'disabled'
            },
            pagination: {
                el: $this.find(".bullet-pagination")[0],
                type: 'bullets',
                bulletClass: 'bullet',
                bulletActiveClass: 'active',
                clickable: true
            },
            /*on: {
                init: function () {
                    cardMass
                },
            }*/
        });
        cardMass.push(cardSlider)
    });
}

function filterInit(){

    if(filterSlider != undefined) {
        filterSlider.destroy();
    }

    filterSlider = new Swiper(".filter-slider .swiper-container", {
        // slidesPerView: 5,
        slidesPerView: 2,
        spaceBetween: 0,
        // loop: false,
        loop: false,
        lazy: true,
        preloadImages: false,
        loadPrevNext: true,
        loadPrevNextAmount: 1,
        navigation: {
            nextEl: $(this).find(".next-slide span")[0],
            prevEl: $(this).find(".prev-slide span")[0],
            disabledClass: 'disabled'
        },
        breakpoints: {
            380: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            746: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            886: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
        }
    });
}

function reInit() {
    if($("#map-item").length) {
        deleteMarkers();
        filterInit();
    }
    if($(".map-places .card-item").length) {
        sliderInit();
        returnMarkers();
    }
    if ($(".choose-date input[name=event-date]").length) {
            calendarInit();
    }
    img_to_svg();
}

$(document).ready(function () {
    var interleaveOffset = 0.5;

    var swiperOptions = {
        loop: true,
        speed: 1000,
        spaceBetween: 0,
        // grabCursor: true,
        watchSlidesProgress: true,
        mousewheelControl: true,
        // keyboardControl: true,
        navigation: {
            nextEl: $(this).find(".next-slide")[0],
            prevEl: $(this).find(".prev-slide")[0],
            disabledClass: 'disabled'
        },
        pagination: {
            el: $(this).find(".bullet-pagination")[0],
            type: 'bullets',
            bulletClass: 'bullet',
            bulletActiveClass: 'active',
            clickable: true
        },
        /* on: {
             progress: function() {
                 var swiper = this;
                 for (var i = 0; i < swiper.slides.length; i++) {
                     var slideProgress = swiper.slides[i].progress;
                     var innerOffset = swiper.width * interleaveOffset;
                     var innerTranslate = slideProgress * innerOffset;
                     swiper.slides[i].querySelector(".slide-wrap").style.transform =
                         "translate3d(" + innerTranslate + "px, 0, 0)";
                 }
             },
             touchStart: function() {
                 var swiper = this;
                 for (var i = 0; i < swiper.slides.length; i++) {
                     swiper.slides[i].style.transition = "";
                 }
             },
             setTransition: function(speed) {
                 var swiper = this;
                 for (var i = 0; i < swiper.slides.length; i++) {
                     swiper.slides[i].style.transition = speed + "ms";
                     swiper.slides[i].querySelector(".slide-wrap").style.transition =
                         speed + "ms";
                 }
             }
         }*/
    };

    mainSlider = new Swiper(".main-slider .swiper-container", swiperOptions);

// document.querySelector('[data-toggle]').addEventListener('click', function(){
//   if (swiper.realIndex == 0) {
//     swiper.slideTo(swiper.slides.length - 1);
//   } else {
//     swiper.slideTo(0);
//   }
// });

// function logIndex () {
//   requestAnimationFrame(logIndex);
//   console.log(swiper.realIndex);
// }
// logIndex();

    if ($(".card-slider .swiper-container").length) {
        sliderInit();
    }

    if ($(".filter-slider .swiper-container").length) {
        filterInit();
    }




    placesSlider = new Swiper(".places-slider > .swiper-container", {
        // slidesPerView: 5,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        // loop: true,
        watchOverflow: true,
        lazy: true,
        preloadImages: false,
        loadPrevNext: true,
        loadPrevNextAmount: 1,
        pagination: {
            el: $(this).find(".places-pagination"),
            type: 'bullets',
            bulletClass: 'bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        on: {
            init: function () {
                cardMass.forEach(function (elem) {
                    elem.update();
                });
            },
        },
        breakpoints: {
            481: {
                slidesPerView: 2,
            },
            666: {
                slidesPerView: 3,
            },
            886: {
                slidesPerView: 4,
            }
        }
    });

    excursionSlider = new Swiper(".excursion-slider .swiper-container", {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        lazy: {
            preloadImages: true,
            loadPrevNext: true,
            loadPrevNextAmount: 200,
        },
        navigation: {
            nextEl: $(".excursion-slider").find(".next-slide"),
            prevEl: $(".excursion-slider").find(".prev-slide"),
            disabledClass: 'disabled'
        },
        pagination: {
            el: $(".excursion-slider").find(".bullet-pagination"),
            type: 'bullets',
            bulletClass: 'bullet',
            bulletActiveClass: 'active',
            clickable: true
        },
        breakpoints: {
            /* 481: {
                 slidesPerView: 2,
             },
             666: {
                 slidesPerView: 3,
             },*/
            886: {
                slidesPerView: 2,
            }
        }
    });

});